import { BreadcrumbList } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

type BreadCrumbSchemaType = {
  data: Record<string, string>[];
  idKey?: string;
  nameKey?: string;
};

export const BreadCrumbListSchemaOrg = ({
  data,
  idKey = 'url',
  nameKey = 'title',
}: BreadCrumbSchemaType) => {
  return (
    <Script
      defer
      {...jsonLdScriptProps<BreadcrumbList>({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: data?.map((item, position) => ({
          '@type': 'ListItem',
          position: position + 1,
          item: {
            '@id': item[idKey],
            name: item[nameKey],
          },
        })),
      })}
    />
  );
};
